import { useParams } from "react-router-dom";
import { useFetchUserCircles } from "@platform/hooks/useFetchUserCircles";
import { SupportContainer } from "../../support/components/Support/SupportContainer";
import { SupportArticleContainer } from "../../support/components/SupportArticle/SupportArticleContainer";
import { usePlatform } from "@platform/PlatformContext";

export function DashboardSupportArticlePage() {
  const { articleId } = useParams();

  const { user } = usePlatform();

  const isUserLoggedIn = !!user;

  // Load user circles data for chat visibility logic
  useFetchUserCircles({ isEnabled: isUserLoggedIn });

  return (
    <SupportContainer articleId={articleId} isArticlePage>
      <SupportArticleContainer
        articleId={articleId}
        className="px-4 pr-4 md:px-0 md:pr-8"
      />
    </SupportContainer>
  );
}

export default DashboardSupportArticlePage;
